import React, { CSSProperties } from "react";
import { getActivityIcon } from "@Images/images-utils";

interface IProps {
    categoryName?: string;
    style?: CSSProperties;
    size?: number;
}

const ActivityIcon: React.FC<IProps> = ({ categoryName, style, size }: IProps) => {
    size = size ?? 24;
    return (
        <div className={"activity-icon"} style={style}>
            {getActivityIcon(categoryName, "#fff", size.toString(), size.toString())}
        </div>
    );
};
export default ActivityIcon;
